import script from "./CityForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CityForm.vue?vue&type=script&lang=ts&setup=true"

import "./CityForm.vue?vue&type=style&index=0&id=09f37c3b&lang=scss"

const __exports__ = script;

export default __exports__